import * as React from "react";
import { useState } from "react";
import { Accordion } from "../../../../../../react-core/Html/Accordion";
import { UserClientSummaryGroupSettingModel } from "../../../../../../Wrap/Models/Domains/Users/UserClientSummaryGroupSettingModel";
import { ClientSummaryGroupModel } from "../../../../../../Wrap/Models/Models/Business/ClientSummary/ClientSummaryGroupModel";
import AdviserSiteTagManager, {
    eventCategoryForGTM,
} from "../../../../../Shared/Cookies/ChoicesCookie/AdviserSiteTagManager";
import { Table } from "../../../../../Shared/Table/Table";
import { EditRangePopup } from "./EditRangePopup";
import { StaticUrls } from "../../../../Resoures/StaticUrls";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";

interface IClientSummaryTableProps {
    data: ClientSummaryGroupModel[];
    saveSetting: (settings) => void;
    setting: UserClientSummaryGroupSettingModel;
}

export const ClientSummaryTable = (props: IClientSummaryTableProps) => {
    const [lightbox, setLightbox] = useState(false);
    const [lightboxData, setLightboxData] = useState<ClientSummaryGroupModel>({});
    const [totalLightbox, setTotalLightbox] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const { addEvent } = new AdviserSiteTagManager();
    const getPtype = (index: number) => {
        switch (index) {
            case 0:
                return "first-range mr-28";
            case 1:
                return "second-range mr-28";
            case 2:
                return "third-range mr-28";
            case 3:
                return "fourth-range mr-28";
            case 4:
                return "fifth-range mr-28";
            case 5:
                return "sixth-range mr-28";
            default:
                break;
        }
    };

    if (!props.data) {return null;}

    const total = props.data.reduce((sum, cur) => (sum = sum + cur.Count), 0);
    return (
        <>
            <Table
                data={props.data}
                isScrollable={false}
                noDefaultCssWrapper
                cssWrapper="client-summary-table no-sided-padding"
                col={[
                    {
                        title: "Range",
                        key: "GroupStartValue",
                        thCssWrapper: "cell-right sr-only",
                        render: (data, row: ClientSummaryGroupModel, index) => {
                            return (
                                <>
                                    <span className={"account-legend " + getPtype(index)}></span>
                                    <p className="range">{row.GroupStartValue}</p>
                                </>
                            );
                        },
                    },
                    {
                        title: (
                            <button
                                className="edit-circle-icon-button label-sr-only"
                                title="Edit"
                                onClick={() => {
                                    addEvent({
                                        event: "clientsummarytab_interaction",
                                        eventParameters: {
                                            eventAction: "interactions",
                                            eventCategory: eventCategoryForGTM.clientSummaryTab,
                                            eventLabel: `edit groups`,
                                        },
                                    });
                                    setShowEdit(true);
                                }}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="text">Edit</span>
                            </button>
                        ),
                        key: "Count",
                        render: (data, row, index) => {
                            return (
                                <button
                                    className="hyperlink"
                                    onClick={() => {
                                        addEvent({
                                            event: "clientsummarytab_interaction",
                                            eventParameters: {
                                                eventAction: "interactions",
                                                eventCategory: eventCategoryForGTM.clientSummaryTab,
                                                eventLabel: `group ${index + 1}`,
                                            },
                                        });
                                        setLightboxData(row);
                                        setLightbox(true);
                                    }}
                                >
                                    {data > 1 ? `${data} Clients` : `${data} Client`}
                                </button>
                            );
                        },
                    },
                ]}
                TotalBody={[
                    { data: "Total", tfTdCssWrapper: "cell-right" },
                    {
                        data: (
                            <a
                                className="total-clients"
                                onClick={() => {
                                    setTotalLightbox(true);
                                }}
                            >
                                {total > 1 ? `${total} clients` : `${total} client`}
                            </a>
                        ),
                    },
                ]}
            />
            {lightbox && (
                <Lightbox
                    cssWrapper="is-default-lightbox"
                    show={lightbox}
                    onClose={() => setLightbox(false)}
                    title={lightboxData?.GroupStartValue?.toString()}
                >
                    <table className="data-table no-sided-padding">
                        <thead>
                            <tr className="sub-head">
                                <th>Account name</th>
                                <th className="cell-right">Account</th>
                                <th className="cell-right">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(lightboxData?.Accounts || []).map((ele) => {
                                return (
                                    <tr>
                                        <td>{ele.AccountName}</td>

                                        <td className="cell-right">
                                            {checkPermission(UserClaim.AdviserPortalPerformanceSummaryCanView) ? (
                                                <a
                                                    onClick={() => {
                                                        window.location.assign(
                                                            StaticUrls.ClientDashboardUrl(ele.HierarchyId, "summary")
                                                        );
                                                    }}
                                                    className="hyperlink"
                                                >
                                                    {ele.ClAccountId}
                                                </a>
                                            ) : (
                                                ele.ClAccountId
                                            )}
                                        </td>
                                        <td className="cell-right">{MoneyDisplayHelper.FromatMoneyDisplay(ele.Value.Amount,CurrencyCode.GBP, true,2)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Lightbox>
            )}
            {totalLightbox && (
                <Lightbox
                    cssWrapper="is-default-lightbox"
                    show={totalLightbox}
                    onClose={() => setTotalLightbox(false)}
                    title="Total accounts"
                >
                    {props.data.map((item) => {
                        return (
                            <Accordion
                                label={item.GroupStartValue.toString()}
                                cssWrapper="accordion-total-clients"
                                isOpen={false}
                            >
                                <div className="pl-34">
                                    <table className="data-table mb-0 no-sided-padding">
                                        <thead>
                                            <tr className="sub-head">
                                                <th>Account name</th>
                                                <th className="cell-right">Account</th>
                                                <th className="cell-right">Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(item.Accounts || []).map((ele) => {
                                                return (
                                                    <tr>
                                                        <td>{ele.AccountName}</td>

                                                        <td className="cell-right">
                                                            {checkPermission(
                                                                UserClaim.AdviserPortalPerformanceSummaryCanView
                                                            ) ? (
                                                                <a
                                                                    onClick={() => {
                                                                        window.location.assign(
                                                                            StaticUrls.ClientDashboardUrl(
                                                                                ele.HierarchyId,
                                                                                "summary"
                                                                            )
                                                                        );
                                                                    }}
                                                                    className="hyperlink"
                                                                >
                                                                    {ele.ClAccountId}
                                                                </a>
                                                            ) : (
                                                                ele.ClAccountId
                                                            )}
                                                        </td>
                                                        <td className="cell-right">{MoneyDisplayHelper.FromatMoneyDisplay(ele.Value.Amount,CurrencyCode.GBP, true,2) }</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </Accordion>
                        );
                    })}
                </Lightbox>
            )}
            {showEdit && (
                <EditRangePopup
                    data={props.setting}
                    isShow={true}
                    onClose={() => setShowEdit(false)}
                    onSave={(setting) => props.saveSetting(setting)}
                />
            )}
        </>
    );
};
